import { MockFactory } from '@tino-frontend/mocks'
import { MeResponse } from '@types'

export const meAPIMock = new MockFactory<MeResponse>({
  display_name: 'Celtino',
  email: 'celtino2@tino.com.br',
  companies: [
    {
      name: 'Buyer company Ltda.',
      id: 'ca42d709-2dd7-4537-9c35-b2e279a14187',
      document_number: '10020030020010',
      document_type: 'CNPJ',
    },
  ],
  is_admin: true,
  id: '',
  document_number: '***.040.293-**',
})
